import React from 'react';

import { FormControl, Box, SelectProps } from '@mui/material';
import {
  MenuItemStyled,
  InputLabelStyled,
  SelectStyled,
  ChevronDownStyled,
} from './select.styled';
import IOption from '@models/option';

type IProps = SelectProps<string> & {
  options: IOption[];
  withBorder?: boolean;
  maxWidth?: number;
};

export const Select: React.FC<IProps> = ({
  options,
  maxWidth,
  onClick,
  fullWidth = false,
  withBorder = false,
  label,
  value,
  variant,
  ...props
}) => {
  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabelStyled>{label}</InputLabelStyled>

      <SelectStyled
        value={value}
        maxWidth={maxWidth}
        label={label}
        onMouseDown={onClick}
        withBorder={withBorder}
        {...props}
        IconComponent={({ ...propsIcon }) => (
          <Box {...propsIcon}>
            <ChevronDownStyled />
          </Box>
        )}
      >
        {options.map((option) => (
          <MenuItemStyled value={option.value} key={option.value}>
            {option.label}
          </MenuItemStyled>
        ))}
      </SelectStyled>
    </FormControl>
  );
};
